import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Shared Prev/Next pager for report list pages backed by fleet_stats.py's
// page/page_size/total_count/total_pages contract (off-route-history,
// eta-drift-history) -- plain prev/next rather than numbered page links
// since these lists are always sorted newest/worst-first and a dispatcher
// is realistically only ever paging a few pages deep, not jumping to page 40.
export default function Pagination({ page, totalPages, totalCount, pageSize, onPageChange }) {
  if (totalCount === 0) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalCount);

  return (
    <div style={styles.wrap}>
      <span style={styles.label}>
        {from}–{to} of {totalCount}
      </span>
      <div style={styles.controls}>
        <button
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          style={{ ...styles.btn, ...(page <= 1 ? styles.btnDisabled : {}) }}
          aria-label="Previous page"
        >
          <ChevronLeft size={15} style={{ width: 15, height: 15, flexShrink: 0 }} />
        </button>
        <span style={styles.pageLabel}>
          Page {page} of {totalPages}
        </span>
        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          style={{ ...styles.btn, ...(page >= totalPages ? styles.btnDisabled : {}) }}
          aria-label="Next page"
        >
          <ChevronRight size={15} style={{ width: 15, height: 15, flexShrink: 0 }} />
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    marginTop: 12, paddingTop: 12, borderTop: "1px solid var(--line)",
    fontSize: 12, color: "var(--muted)", flexWrap: "wrap", gap: 10,
  },
  label: { fontVariantNumeric: "tabular-nums" },
  controls: { display: "flex", alignItems: "center", gap: 8 },
  pageLabel: { fontSize: 12, color: "var(--ink-2)", fontVariantNumeric: "tabular-nums", minWidth: 90, textAlign: "center" },
  btn: {
    display: "flex", alignItems: "center", justifyContent: "center", width: 28, height: 28,
    background: "var(--card)", border: "1px solid var(--line)", borderRadius: 7, cursor: "pointer",
    color: "var(--ink)",
  },
  btnDisabled: { opacity: 0.4, cursor: "not-allowed" },
};
